module.exports = __webpack_public_path__ + "img/1.c5a5c625.jpg";